import { motion } from 'framer-motion';
import { useState } from 'react';

export function BestToursSection() {
  const [selectedCategory, setSelectedCategory] = useState('전체');

  const categories = [
    { name: '전체', icon: 'ri-grid-line' },
    { name: '전세버스', icon: 'ri-bus-line' },
    { name: '미니버스', icon: 'ri-taxi-line' },
    { name: '스타리아', icon: 'ri-car-line' },
    { name: '마사지', icon: 'ri-heart-pulse-line' },
    { name: '족욕', icon: 'ri-footprint-line' },
    { name: '쇼핑', icon: 'ri-shopping-bag-3-line' }
  ];

  const products = [
    {
      id: 1,
      title: '대형 VIP 리무진 전세버스',
      category: '전세버스',
      price: '금액별도문의',
      image: 'https://static.readdy.ai/image/c1ead532c50398fda057e46e940be938/8b181ed14288745e18a97aecd517475f.jpeg',
      badge: '전세버스',
      rating: 5.0,
      reviews: 128
    },
    {
      id: 2,
      title: '미니버스',
      category: '미니버스',
      price: '금액별도문의',
      image: 'https://static.readdy.ai/image/c1ead532c50398fda057e46e940be938/a850266f7168de417a6fc53f2d23fb78.jpeg',
      badge: '미니버스',
      rating: 4.9,
      reviews: 95
    },
    {
      id: 3,
      title: '스타리아',
      category: '스타리아',
      price: '금액별도문의',
      image: 'https://static.readdy.ai/image/c1ead532c50398fda057e46e940be938/3782faea5bd3cbcbaedfcb9b65dacbed.jpeg',
      badge: '인기',
      rating: 4.9,
      reviews: 156
    },
    {
      id: 7,
      title: '제주 프리미엄 마사지',
      category: '마사지',
      price: '금액별도문의',
      image: 'https://static.readdy.ai/image/c1ead532c50398fda057e46e940be938/2d9603ac7164d2741379274a3f62be5c.jpeg',
      badge: '힐링',
      rating: 5.0,
      reviews: 167
    },
    {
      id: 8,
      title: '족욕 카페 체험',
      category: '족욕',
      price: '금액별도문의',
      image: 'https://public.readdy.ai/ai/img_res/aa641643a12657035b4b52116300b352.jpg',
      badge: '휴식',
      rating: 4.8,
      reviews: 134
    },
    {
      id: 10,
      title: '제주 특산품 쇼핑',
      category: '쇼핑',
      price: '금액별도문의',
      image: 'https://readdy.ai/api/search-image?query=Jeju%20specialty%20products%20store%20interior%2C%20traditional%20Korean%20souvenirs%2C%20local%20food%20products%2C%20tangerines%2C%20cosmetics%2C%20beautifully%20arranged%20display%2C%20modern%20retail%20space%2C%20warm%20lighting%2C%20professional%20product%20photography&width=800&height=600&seq=shopping-002&orientation=landscape',
      badge: '특산품',
      rating: 4.9,
      reviews: 112
    }
  ];

  const filteredProducts = selectedCategory === '전체' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <section id="best-tours" className="py-20 sm:py-24 md:py-28 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-[#FF8E53]/10 to-[#0E7FC0]/10 px-6 py-3 rounded-full mb-6 sm:mb-8"
          >
            <i className="ri-star-fill text-[#FFD700] text-xl"></i>
            <span className="text-[#2C2C2C] text-base sm:text-lg font-medium">제주블리 베스트</span>
          </motion.div>
          
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#2C2C2C] mb-8 sm:mb-10 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            제주블리 프리미엄 서비스
          </motion.h2>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex flex-col gap-4 sm:gap-5 max-w-3xl mx-auto"
          >
            <p className="text-lg sm:text-xl md:text-2xl text-gray-700 leading-relaxed flex items-center justify-center gap-3">
              <span className="text-2xl">🚍</span>
              <span>택시 투어 / 벤츠 스프린터 / 대형 VIP 리무진</span>
            </p>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-700 leading-relaxed flex items-center justify-center gap-3">
              <span className="text-2xl">📸</span>
              <span>웨딩 스냅 / CF &amp; 방송 촬영 / 워크숍 이동</span>
            </p>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-700 leading-relaxed flex items-center justify-center gap-3">
              <span className="text-2xl">⛳</span>
              <span>골프 부킹 / 한라산 등반 / 힐링 자유 여행</span>
            </p>
          </motion.div>
        </div>

        {/* Category Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-12 sm:mb-16"
        >
          {categories.map((category, index) => (
            <motion.button
              key={category.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setSelectedCategory(category.name)}
              className={`flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all whitespace-nowrap shadow-lg ${
                selectedCategory === category.name
                  ? 'bg-gradient-to-r from-[#FF8E53] to-[#ff7a3d] text-white shadow-[#FF8E53]/30'
                  : 'bg-white text-gray-700 hover:bg-gray-50 hover:shadow-xl'
              }`}
            >
              <i className={`${category.icon} text-lg sm:text-xl`}></i>
              <span className="text-sm sm:text-base">{category.name}</span>
            </motion.button>
          ))}
        </motion.div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
          {filteredProducts.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10, scale: 1.02 }}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                {/* Image */}
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  
                  {/* Badge */}
                  <div className="absolute top-4 left-4">
                    <span className="bg-gradient-to-r from-[#FF8E53] to-[#ff7a3d] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                      {product.badge}
                    </span>
                  </div>

                  {/* Rating */}
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-2 rounded-full flex items-center gap-1 shadow-lg">
                    <i className="ri-star-fill text-[#FFD700] text-sm"></i>
                    <span className="text-sm font-bold text-[#2C2C2C]">{product.rating}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-xs font-medium text-[#0E7FC0] bg-[#0E7FC0]/10 px-3 py-1 rounded-full">
                      {product.category}
                    </span>
                    <span className="text-xs text-gray-500 flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {product.reviews}개 후기
                    </span>
                  </div>

                  <h3 className="text-xl font-bold text-[#2C2C2C] mb-3 group-hover:text-[#FF8E53] transition-colors">
                    {product.title}
                  </h3>

                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-[#FF8E53]">
                      {product.price}
                    </div>
                    <motion.button
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      className="w-10 h-10 bg-gradient-to-r from-[#FF8E53] to-[#ff7a3d] rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-xl transition-all"
                    >
                      <i className="ri-arrow-right-line text-xl"></i>
                    </motion.button>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-16 sm:mt-20"
        >
          <motion.button
            whileHover={{ scale: 1.05, boxShadow: '0 20px 40px rgba(14, 127, 192, 0.3)' }}
            whileTap={{ scale: 0.95 }}
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-gradient-to-r from-[#0E7FC0] to-[#0a5f92] text-white px-10 sm:px-12 py-5 sm:py-6 rounded-full text-lg sm:text-xl font-bold shadow-2xl hover:shadow-[#0E7FC0]/50 transition-all flex items-center gap-3 whitespace-nowrap mx-auto"
          >
            <i className="ri-customer-service-2-line text-2xl"></i>
            더 많은 상품 문의하기
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}
